module.exports = __webpack_public_path__ + "static/media/Sharp Low-Power Displays White Paper.cd00a52e.pdf";